import PropTypes from "prop-types";
import React from "react";

import initials from "../utils/initials";

const Users = (props) => {
  const { client } = props;
  const users = client.users || [];

  const usersTable = users.map((user) => (
    <div
      key={user.id}
      className="bg-gray-50 px-3 py-2 mb-1.5 flex justify-between items-center gap-3"
    >
      <div className="flex items-center gap-3 min-w-0">
        <div className="w-6 h-6 shrink-0 rounded-full bg-white border border-gray-300 flex items-center justify-center text-[10px] font-semibold">
          {initials(user.name, user.email)}
        </div>
        <div className="min-w-0">
          <div className="text-xs font-medium truncate">
            {user.name || user.email}
          </div>
          <div className="text-[11px] text-gray-500 truncate">{user.email}</div>
        </div>
      </div>
      {user.admin && (
        <span className="shrink-0 bg-white text-grey-800 text-[10px] px-1.5 py-0.5 border border-gray-300">
          Administrator konta
        </span>
      )}
    </div>
  ));

  return (
    <div className="mt-10">
      <div className="border-b mt-6 pb-2">
        <span className="text-sm font-medium">
          Użytkownicy ({users.length}/{client.user_limit})
        </span>
      </div>

      <div className="mt-3 max-h-52 overflow-y-auto pr-1">
        {users.length ? (
          usersTable
        ) : (
          <div className="text-sm text-gray-500">Brak użytkowników</div>
        )}
      </div>
    </div>
  );
};

export default Users;

Users.propTypes = {
  client: PropTypes.object,
};
